import React, { useEffect } from "react";
import Quill, { RangeStatic, Sources } from "quill";
import MentionBlot from "./Modules/Mention";
import "quill/dist/quill.core.css";
import "./indexv2.less";
import { EventEmitter } from "events";
import { IRect } from "@/types/chat/Base";
// import CustomClipboard from "./Modules/clipboard";
import CustomClipboard from "@/components/Work/Comment/InputComment/JEditor/Modules/clipboard";
import Emoji from "./Modules/emoji";
import CustomImageBlot from "./Modules/image";
import { formatAtName } from "@/utils/chat/index";
import "quill/dist/quill.snow.css";
import { getPreviewImageModal } from "@/components/chat/utils/commonMessageModal";
import { Tooltip, message } from "antd";
import Session from "@jd/jdee.im.sdk/lib/es/model/Session";
import { isAIChatSession } from "@/utils/chat/session";
import { FocusSDK as focusSDK, isFocusEnv } from "@/utils";
import classNames from "classnames";
import ChatEvent from "@/components/chat/view/ChatEvent";
const Delta = Quill.import("delta");
interface IProps {
  content?: string;
  contentChange?: (delta: any, oldDelta: any, source: Sources) => void;
  upload?: (files: any[], range: any, type?: string) => void;
  onEditorKeyDown?: any;
  placeholder?: string;
  disableEnter?: boolean;
  maxLength?: number;
  readOnly?: boolean;
  onCompositionStart?: Function;
  onCompositionEnd?: Function;
  selectedSession: Session;
  inputMenu?: any;
  replyText?: any;
  isDisabled?: boolean;
}

interface IState {
  atStartIndex: number;
  atEndIndex: number;
  isOverFlow: boolean;
}

Quill.register({
  "formats/mention-link": MentionBlot,
  "formats/custom-emoji": Emoji,
  "formats/image": CustomImageBlot
});
Quill.register("modules/clipboard", CustomClipboard, true);

export const Events = new EventEmitter();
class JEditor extends React.Component<IProps, IState> {
  quill: Quill | null = null;
  atActive = false;
  disableEnter = false;
  events: EventEmitter;
  isCompositionMode = false;
  quillModal = false;
  hasInput = false;
  hasReply = false;
  private editorRef = React.createRef<HTMLDivElement>();
  private toolbarRef = React.createRef<HTMLDivElement>();
  private measureElement: HTMLDivElement;

  constructor(props: IProps) {
    super(props);
    this.events = Events;
    this.state = {
      atStartIndex: 0,
      atEndIndex: 0,
      isOverFlow: false
    };
    this.disableEnter = props.disableEnter || false;
    this.quillModal = false;
    // 创建测量元素（不挂载到 React DOM）
    this.measureElement = document.createElement('div');
    this.measureElement.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: pre;
    `;
    document.body.appendChild(this.measureElement);
  }

  getQuill = () => {
    return this.quill;
  };
  getText(index?: number, length?: number) {
    if (!this.quill) {
      return "";
    }
    return this.quill.getText(index, length);
  }

  clearMessage = () => {
    if (!this.quill) {
      return "";
    }
    this.quill.setContents(new Delta());
  };

  handleDealImg = (dom: any) => {
    if (dom.getAttribute("class") !== "e-image") {
      return;
    }
    const allImages = document.querySelectorAll(".ql-editor > p > img.e-image");
    let imageArr: any[] = [];
    if (isFocusEnv()) {
      allImages.forEach((img: any, index: number) => {
        const src = img.getAttribute("src");
        const title = img.getAttribute("fileName");
        const imageId = img.getAttribute("imageId");
        imageArr.push({ muuid: imageId, url: src, fileName: title, kind: "image" });
      });
    }
    const src = dom.getAttribute("src");
    const title = dom.getAttribute("fileName");
    const imageId = dom.getAttribute("imageId");
    getPreviewImageModal({
      message: { muuid: imageId, url: src, fileName: title },
      isMergeForward: true,
      modalMessages: imageArr
    });
  };

  insertImage = (image: { url: string; width: Number; height: Number; title: string }) => {
    if (!this.quill) {
      return "";
    }
    if (isFocusEnv()) {
      focusSDK.setWindowFrame("focus");
    };
    this.quill.focus();
    const addImageRange = this.quill.getSelection();
    const newRange = 0 + (addImageRange !== null ? addImageRange.index : 0);
    this.quill.insertEmbed(newRange, "image", {
      url: image.url,
      width: image.width,
      height: image.height,
      title: image.title
    });
    this.quill.setSelection(newRange + 1, 0);
  };

  hasImage = () => {
    if (!this.quill) {
      return "";
    }
    const delta = this.quill.getContents();
    let hasImage = false;
    for (const item of delta.ops) {
      const insert: any = item.insert;
      if (insert && insert.image) {
        hasImage = true;
        return hasImage;
      }
    }
    return hasImage;
  };

  imageCount = (content?: any) => {
    if (!this.quill) {
      return "";
    }
    const delta = content || this.quill.getContents();
    let imageCount = 0;
    delta.forEach(function (item: any) {
      if (item.insert && item.insert?.image) {
        imageCount += 1;
      }
    });
    return imageCount;
  }

  isSingleImageOnly = () => {
    if (!this.quill) {
      return "";
    }
    const delta = this.quill.getContents();
    let imageCount = 0;
    let image: any;
    delta.forEach(function (item: any) {
      if (item.insert && !item.insert?.image && item.insert !== "\n") {
        imageCount += 1;
      }
      if (item.insert && item.insert?.image) {
        imageCount += 1;
        image = item.insert.image;
      }
    });
    if (imageCount === 1) {
      return image;
    }
    return false;
  };

  setQuillModal = (isQullModal: boolean) => {
    this.quillModal = isQullModal;
  };

  setIsOverFlow = (isOverFlow: boolean) => {
     this.setState({ isOverFlow });
  };

  colorPickerHandler = (value: any) => {
    const colorline: any = document.querySelector(".ql-transparent.ql-stroke");
    if (value) {
      switch (value) {
        case "#e60000":
          value = "#F3210E";
          break;
        case "#ff9900":
          value = "#FF7800";
          break;
        case "#ffff00":
          value = "#63BD08";
          break;
        case "#008a00":
          value = "#20C9D8";
          break;
        case "#0066cc":
          value = "#3641FF";
          break;
        case "#9933ff":
          value = "#8F959E";
          break;
      }
      this.quill?.format("color", value);
      colorline.style.stroke = value;
    } else {
      this.quill?.format("color", "#232930");
      colorline.style.stroke = "#232930";
    }
  };

  /**
   * 获取文本消息，包括@ 人的数据
   */
  getTextMessage = () => {
    if (!this.quill) {
      return "";
    }
    const delta = this.quill.getContents();
    let tempText = "";
    let text = "";
    const userIds: string[] = [];
    const imageList: any[] = [];
    let count = 1;
    delta.forEach((op) => {
      const listType = op?.attributes?.list;
      if (!op.insert) {
        return;
      }
      switch (typeof op.insert) {
        case "string":
          if (op.insert === "\n" && listType === "bullet") {
            count = 1;
            text += `・${tempText}\n`;
            tempText = "";
          } else if (op.insert === "\n" && listType === "ordered") {
            text += `${count}. ${tempText}\n`;
            count++;
            tempText = "";
          } else if (op.insert.indexOf("\n") > -1) {
            const lastNewlineIndex = op.insert.lastIndexOf('\n');
            const firstPart = op.insert.substring(0, lastNewlineIndex + 1);
            const secondPart = op.insert.substring(lastNewlineIndex + 1);
            count = 1;
            text += `${tempText}${firstPart}`;
            tempText = "";
            if (secondPart) {
              tempText = secondPart;
            }
          } else {
            tempText += op.insert;
          }
          break;
        case "object":
          // eslint-disable-next-line no-case-declarations
          const obj: any = op.insert;
          if (obj["mention-link"]) {
            const value = obj["mention-link"];
            // text += '@' + value.name; custom-emoji
            tempText += formatAtName(value.name);
            userIds.push(value.id);
          }
          if (obj["custom-emoji"]) {
            const value = obj["custom-emoji"];
            tempText += value;
          }
          if (obj["image"]) {
            const value = obj["image"];
            const title = value.title.length > 9 ? `${value.title.slice(0, 2)}...${value.title.slice(-7)}` : value.title;
            let includeEnter = tempText?.length ? tempText : text;
            if (includeEnter.endsWith("\n")) {
              tempText += `【图片:${title}】\n`;
            } else {
              tempText += `\n【图片:${title}】\n`;
            }
            imageList.push(value);
          }
          break;
        default:
          break;
      }
    });
    text = `${text}${tempText}`;
    if (text[text.length - 1] === "\n") {
      text = text.slice(0, -1);
    }
    return { text, userIds, delta, imageList };
  };

  public changeDisableEnter = (flag: boolean) => {
    this.disableEnter = flag;
  };

  public insertText = (str: string, source: any = "user") => {
    if (!this.quill) {
      return;
    }
    this.quill.focus();
    // if (!this.quill) {
    //     return;
    // }
    const range = this.quill.getSelection();
    if (!range) {
      return;
    }
    this.quill.insertText(range.index, str, source);
    this.quill.setSelection(range.index + str.length, 0);
  };

  public changeAtActive = (flag: boolean) => {
    this.atActive = flag;
  };

  public changePlaceholder = (placeholder: string) => {
    if (!this.quill) {
      return;
    }
    this.quill.root.setAttribute("data-placeholder", placeholder);
  };

  // 获取选择文本的位置维度信息， 如果是多条表明选择了多行
  public getSelectionRects(range?: RangeStatic): IRect[] {
    const quill = this.getQuill();
    const results: IRect[] = [];
    // if (!quill || !quill.container) {
    //     return results;
    // }
    // if (!range) {
    //     const r = quill.getSelection();
    //     if (!r) {
    //         return results;
    //     }
    //     // eslint-disable-next-line no-param-reassign
    //     range = r;
    // }
    // const containerRect = quill.container.getBoundingClientRect();
    // const startLeaf = quill.getLeaf(range.index);
    // const endLeaf = quill.getLeaf(range.index + range.length);
    // const dRange = document.createRange();
    // dRange.setStart(startLeaf[0].domNode, startLeaf[1]);
    // dRange.setEnd(endLeaf[0].domNode, endLeaf[1]);
    // const rects = rangefix.getClientRects(dRange);
    // const l = rects.length;
    // if (!l) {
    //     return results;
    // }
    // for (let i = 0; i < l; i++) {
    //     const item = rects[i];
    //     results.push({
    //         top: item.top - containerRect.top,
    //         left: item.left - containerRect.left,
    //         width: item.width,
    //         height: item.height,
    //     });
    // }
    results.push({
      top: 0,
      left: 0,
      width: 0,
      height: 0
    });
    return results;
  }

  /**
   * 处理是否拦截回车默认事件
   */
  handleEnterDefault = () => {
    if (this.disableEnter) {
      return false;
    }
    return true;
  };

  getModule(name: string): any {
    if (!this.quill) {
      return null;
    }
    return this.quill.getModule(name);
  }

  componentDidMount() {
    this.initQuill();
  }

  componentWillUnmount() {
    
    this.removeEventBind();
    document.body.removeChild(this.measureElement); // 清理测量元素
  }

  initQuill() {
    const options = {
      // debug: 'info',
      modules: {
        toolbar:
          isAIChatSession(this.props.selectedSession) || !this.props.inputMenu
            ? null
            : {
                container: "#toolbar-container",
                handlers: { color: this.colorPickerHandler }
              },
        keyboard: {
          bindings: {
            enter: {
              key: 13,
              handler: this.handleEnterDefault
            },
            bold: {
              key: "B",
              shortKey: true,
              handler: () => {return false}
            },
            italic: {
              key: "I",
              shortKey: true,
              handler: () => {return false}
            },
            underline: {
              key: "U",
              shortKey: true,
              handler: () => {return false}
            },
            indent: {
              key: "tab",
              shortKey: false,
              handler: () => {return false}
            }
          }
        },
        clipboard: {
          upload: (range: any, files: any, type?: string) => {
            //   uploader(this.quill, this.props.page.id, range, files);
            if (this.props.upload) {
              this.props.upload(files, range, type);
            }
          },
          matchVisual: false
        }
      },
      formats: [
        "background",
        "bold",
        "color",
        "font",
        "code",
        "italic",
        "link",
        "size",
        "strike",
        "script",
        "underline",
        "blockquote",
        "header",
        "indent",
        "list",
        // 'list', // <-- commented-out to suppress auto bullets
        "align",
        "direction",
        "code-block",
        "formula",
        "image",
        "video",
        "mention-link",
        "custom-emoji"
      ],
      placeholder: this.props.placeholder || "",
      readOnly: this.props.readOnly,
      theme: "snow",
      scrollingContainer: "#jeditor"
    };
    const editor = new Quill("#jeditor", options);
    if(this.props.isDisabled !== undefined && this.props.isDisabled === true){
      editor.blur(); // 移除焦点
      editor.disable();
    }
    this.quill = editor;
    this.addEventBind();
    // this.addClipboard();
    const aa: any = window;
    aa.quill = editor;
  }

  // addClipboard = () => {
  //     if (!this.quill) {
  //         return null;
  //     }
  //     // AddClipboard(this.quill);
  // };

  setColor = () => {
    if (!this.quill) {
      return;
    }
    const colorline: any = document.querySelector(".ql-transparent.ql-stroke");
    if (!colorline) {
      return;
    }
    const colorAtCursor = this.quill.getFormat().color;
    colorline.style.cssText = `stroke: ${colorAtCursor} !important`;
  }

  onTextChange = (delta: any, oldDelta: any, source: Sources) => {    
    if (!this.quill) {
      return "";
    }
    this.setColor();
    const length = this.quill?.getLength();
    
    if (length > 0) {
      this.hasInput = true;
    }

    if (length === 1) {
      this.changePlaceholder(this.props.placeholder || "请输入消息");
       this.hasInput = false;
       if(!this.hasReply){
          this.setIsOverFlow(false);
       }
    }
    if (this.props.contentChange) {
      this.isCompositionMode = false;
      this.props.contentChange(delta, oldDelta, source);
    }
    if (source !== "user") {
      return;
    }

    // 判断是否overflow
     this.calcIsOverFlow();
    // 限制输入长度
    if (this.props.maxLength) {
      const { maxLength } = this.props;
      const length = this.quill?.getLength();
      if (length && length > maxLength + 1) {
        const delta = new Delta().retain(maxLength).delete(length - maxLength - 1);
        this.quill?.updateContents(delta, "api");
        this.isCompositionMode = false;
        message.error("最多可输入2000字");
      }
    }
    this.scrollToBottom(1);
  };

  onSelectionChange = (
    range: { index: number; length: Number },
    oldRange: { index: Number; length: Number },
    source: String
  ) => {
    if (!range) {
      return;
    }
    this.setColor();
    if (this.events) {
      this.events.emit("editor-selection-change", range, source);
    }
  };

  onInputBlur = () => {
    if (this.events) {
      this.events.emit("editor-on-focus", false);
    }
  };

  onInputFocus = () => {
    if (this.events) {
      this.events.emit("editor-on-focus", true);
    }
  };

  scrollToBottom = (type: number) => {
    if (type === 1) {
      if (this.editorRef.current) {
        this.editorRef.current.scrollTop = this.editorRef.current.scrollHeight;
      }
    } else {
      const jeditorDOM = document.getElementById("jeditor");
      if (jeditorDOM) {
        jeditorDOM.scrollTop = document.getElementById("jeditor")?.scrollHeight || 0;
      }
    }
  };

  // 判断是否overflow【解决有输入情况下切换新旧输入框和切换会话的bug】
  calcIsOverFlow = () => {
    if (!this.quillModal) {      
      // 系统性地检查输入框内容：
      const inputContent = this.quill?.getContents().ops || [];
      let inputText = "";
      // console.log("输入框收起状态，检查内容是否溢出===输入内容", inputContent);
      for (let op of inputContent) {
        const insert: any = op.insert;    
        if (insert && typeof insert === 'object') {
          if(insert.image){
            // console.log("输入框收起状态，检查内容是否溢出===有图片", insert.image);
            // 存在图片
            this.setIsOverFlow(true);
            return;
          }else if(insert['custom-emoji']){
            inputText += "OO";
          }else if(insert['mention-link']){
             inputText += " @" + insert['mention-link'].name + insert['mention-link'].alias;
          }
        }else{
          inputText += insert;
        }
      };
      // console.log("输入框收起状态，检查内容是否溢出===输入内容转字符", inputText);
      // 存在多个换行符时直接 overflow = true
      const regex = /\n/g;
      const matches = inputText?.match(regex);
      const count = matches ? matches.length : 0;
      if (count > 1) {
        this.setIsOverFlow(true);
      } else {
        if (inputText) {
          this.measureElement.textContent = inputText || ' ';
          const textWidth = this.measureElement.offsetWidth;
          if(textWidth < 200){
            this.setIsOverFlow(false);
            return;
          }
          // 计算可用宽度（容器宽度 - 工具栏宽度 - 边距）
          let editorContainer;
          if (this.editorRef.current?.parentElement) {
            editorContainer = this.editorRef.current?.parentElement;
            // console.log("输入框收起状态，检查内容是否溢出===editorContainer", editorContainer); 
            const containerWidth = editorContainer.offsetWidth;
            const toolbarWidth = this.toolbarRef.current?.offsetWidth;
            const availableWidth = containerWidth - (toolbarWidth || 0) - 30; // 边距补偿     
            // console.log("输入框收起状态，检查内容是否溢出===textWidth&availableWidth", this.measureElement, textWidth, containerWidth, toolbarWidth, availableWidth);
            if (textWidth > availableWidth) {
              this.setIsOverFlow(true);
            } else {
              this.setIsOverFlow(false);
            }
          }
        }
      }

    }
  }

  getSelection = () => {
    if (!this.quill) {
      return null;
    }
    const range = this.quill.getSelection();
    return range;
  };

  focus = () => {
    if (!this.quill) {
      return null;
    }
    this.quill.focus();
  };

  addEventBind() {
    if (!this.quill) {
      return;
    }
    this.quill.on("text-change", this.onTextChange);
    this.quill.on("selection-change", this.onSelectionChange);
    this.quill.root.addEventListener("blur", this.onInputBlur);
    this.quill.root.addEventListener("focus", this.onInputFocus);
  }

  removeEventBind() {
    if (!this.quill) {
      return;
    }
    this.quill.off("text-change", this.onTextChange);
    this.quill.off("selection-change", this.onSelectionChange);
    this.quill.root.removeEventListener("blur", this.onInputBlur);
    this.quill.root.removeEventListener("focus", this.onInputFocus);
  }

  onEditorKeyDown = (e: React.KeyboardEvent) => {
    // log.debug('editor key down', e.keyCode);
    if (this.events) {
      this.events.emit("editor-keyDown", e);
    }

    if (this.props.onEditorKeyDown) {
      this.props.onEditorKeyDown(e);
    }
    // 如果是中文模式，拦截一下回车，不发送消息
    if (this.isCompositionMode && e.key === "Enter") {
      e.stopPropagation();
    }
    if (!this.isCompositionMode && e.key === "Enter") {
      this.hasReply = false;
    }

  };

  onCompositionStart = (e: any) => {
    if (!this.quill) {
      return null;
    }
    const length = this.quill?.getLength();
    if (length === 1) {
      this.changePlaceholder("");
    }
    if (this.props.onCompositionStart) {
      this.props.onCompositionStart();
      return;
    }
    this.isCompositionMode = true;
  };
  onCompositionEnd = () => {
    if (!this.quill) {
      return null;
    }
    const length = this.quill?.getLength();
    if (length === 1) {
      this.changePlaceholder(this.props.placeholder || "请输入消息");
    }
    if (this.props.onCompositionEnd) {
      this.props.onCompositionEnd();
      return;
    }
    this.isCompositionMode = false;
  };

  render() {
    return (
      <>
       {this.props.replyText ? this.props.replyText() : null}  
       <div className={classNames("quill-editor-v2", {
            "custom-quill-container": !this.quillModal,
            "text-overflow": this.state.isOverFlow && !this.quillModal,
            "quill-modal-open": this.quillModal
          })}>  
        {!isAIChatSession(this.props.selectedSession) && this.props.inputMenu ? (
          <div ref={this.toolbarRef} id="toolbar-container" className={classNames("quill-toolbar-container", {
            "bottom-right": this.state.isOverFlow && !this.quillModal,
            "light-send-icon": this.hasInput,
            "ql-snow ql-toolbar": true
          })}>
            {this.props.inputMenu()}
            <div
              className="quill-toolbar"
              style={{
                display: this.quillModal ? "flex" : "none"
              }}
            >
              <Tooltip key="12" title="字体大小" placement="top">
                <span className="ql-formats">
                  <select className="ql-size" />
                </span>
              </Tooltip>
              <Tooltip key="13" title="字体颜色" placement="top">
                <span className="ql-formats">
                  <select className="ql-color" />
                </span>
              </Tooltip>
              <Tooltip key="14" title="加粗" placement="top">
                <span className="ql-formats">
                  <button
                    className="ql-bold"
                    clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_Bold"
                  />
                </span>
              </Tooltip>
              <Tooltip key="15" title="斜体" placement="top">
                <span className="ql-formats">
                  <button
                    className="ql-italic"
                    clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_Italic"
                  />
                </span>
              </Tooltip>
              <Tooltip key="16" title="中划线" placement="top">
                <span className="ql-formats">
                  <button
                    className="ql-strike"
                    clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_Strikethrough"
                  />
                </span>
              </Tooltip>
              <Tooltip key="17" title="有序列表" placement="top">
                <span className="ql-formats">
                  <button
                    className="ql-list"
                    value="ordered"
                    clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_OrderedList"
                  />
                </span>
              </Tooltip>
              <Tooltip key="18" title="无序列表" placement="top">
                <span className="ql-formats">
                  <button
                    className="ql-list"
                    value="bullet"
                    clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_UnorderedList"
                  />
                </span>
              </Tooltip>
            </div>
          </div>
        ) : null}
        <div className="quill-editor-container" ref={this.editorRef} >
          <div
            className="jeditor"
            id="jeditor"
            onKeyDown={this.onEditorKeyDown}
            onCompositionStart={this.onCompositionStart}
            onCompositionEnd={this.onCompositionEnd}
            onClick={(e) => {
              this.handleDealImg(e.target);
            }} />
        </div>
      </div>
      </>
      
    );
  }
}

export default JEditor;
